const messages = {
  title: "Salgskampanjer",
  desc: "Bruk våre salgskampanjer aktivt med kundene dine. Du kan selvfølgelig tilby kundene begge kampanjene. Les mer om Dekkgaranti og Drive Our Best nedenfor.",
  participation: {
    title: "Søk om deltakelse nå",
    desc: "Vil du implementere en eller fleire av våre kampanjer i butikken din? Da kan du søke om deltakelse her. Virksomheten din aktiveres for kampanje(n) og du mottar kampanjemateriell innen 4 uker.<br/><br/>Gjer ditt valg:",
    request: "SØK OM DELTAKELSE",
    success: "Takk, forespørselen din er sendt",
  },
};
export default {
  messages,
};
